import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-tooltip',
			dom: {
				close: '.js-tooltip-close',
				open: '.js-tooltip-open'
			},
			classes: {
				active: 'b-tooltip_state_active'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$document = $(document);

		this.classes = {
			active: 'b-tooltip_state_active'
		};
	}

	toggle(event) {
		const $target = $(event.target);
		const $tooltip = $target.closest(this.$el);
		if ($tooltip.hasClass(this.options.classes.active)) {
			this.close($tooltip);
		} else {
			this.open($tooltip);
		}
		event.preventDefault();
	}

	open($el = false) {
		const $tooltip = $el === false ? this.$el : $el;
		$tooltip.addClass(this.options.classes.active);
	}

	close($el = false) {
		const $tooltip = $el === false ? this.$el : $el;
		$tooltip.removeClass(this.options.classes.active);
	}

	onDocumentAction(event) {
		const self = this;
		const $target = $(event.target);
		self.$el.each(function () {
			const $tooltip = $(this);
			if (!$target.is($tooltip) && !$target.closest($tooltip).length && $tooltip.hasClass(self.options.classes.active)) {
				self.close($tooltip);
			}
		});
	}

	render() {
		const self = this;
		if (this.$el.length) {
			this.$el
				.on('click.tooltip', this.options.dom.open, this.toggle.bind(this))
				.on('click.tooltip', this.options.dom.close, this.toggle.bind(this));
			this.$document.on('click', this.onDocumentAction.bind(this));
			this.$el.addClass('tooltipInited');
		}

		setInterval(function () {
			$('.js-tooltip:not(.tooltipInited)')
				.on('click.tooltip', self.options.dom.open, self.toggle.bind(self))
				.on('click.tooltip', self.options.dom.close, self.toggle.bind(self))
				.addClass('tooltipInited');
			self.$el = $('.js-tooltip');
		}, 1000);
	}
}



// WEBPACK FOOTER //
// ./app/blocks/tooltip/tooltip.js